/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./reviewsCardBlock.css";
import "./responsive.css";
import axios from "axios";
import ReviewsCard from "../../components/ReviewsCard/ReviewsCard";
import { useInView } from 'react-intersection-observer';

const ReviewsCardBlock = ({ container }) => {
    const dataSourceTitle = container.getAttribute("data-source-title");
    const [ref, inView] = useInView({
        triggerOnce: true, // Only trigger once when entering the viewport
    });
    return (
        <>
            <div className="active-listings-reviews-cards-block-title">
            <h4>{dataSourceTitle}</h4>
            </div>
            <div className="active-listings-reviews-cards-block-wrapper" ref={ref}>
            {inView && (
                <ReviewsCard container={container} />
            )}
            </div>
        </>
    );
};

export default ReviewsCardBlock;
